import type { PortableTextTypeComponent } from '@portabletext/react';

// 08-09-2022 - the only style of TextBreak is `hr`
const TextBreak: PortableTextTypeComponent = () => (
  <hr className="clear-both my-6" />
);

export default TextBreak;

export const TextBreakHtml: PortableTextTypeComponent = () => <hr />;
